export default __webpack_public_path__ + "static/10-95a9351624abdc9f18268e5c0b7067b7.png";